<template>
	<div>
		<div class="feedB" v-if="yydList.length">
			<div class="feedItem" v-for="(item, index) in yydList" :key="index" :class="{ active: item.isOpen }" @click="item.isOpen = !item.isOpen">
				<div class="feedH">
					<div class="feedTit">
						<div class="feedStatus" :class="{ feedStatus1: item.recover ? true : false }">
							{{ item.recover ? '已回复' : '未回复' }}
						</div>
						<h2>{{ item.title }}</h2>
					</div>
					<div class="feedIcon">
						<span>{{ item.isOpen ? '收起' : '查看' }}</span>
						<img src="@/assets/img/xla.png" v-show="!item.isOpen" alt="" />
						<img src="@/assets/img/sqi.png" v-show="item.isOpen" alt="" />
					</div>
				</div>
				<div class="feedCont">
					<div class="feedContTop">
						<p v-html="$txtGs(item.content || '')"></p>
						<div class="feedContImgs" v-if="item.coverUrls">
							<img :src="$imgUrl + i" v-for="i in item.coverUrls?.split(',')" :key="i" alt="" @click.stop="lookImgFn(i)" />
						</div>
						<el-dialog :visible.sync="dialogVisible">
							<img width="100%" :src="lookImg" alt="" />
						</el-dialog>
					</div>
					<div class="feedContBot" v-if="item.recover">
						<div class="tit">回复内容</div>
						<p>{{ item.recover }}</p>
						<div class="times">回复时间：{{ item.responseTime | momentYR('YYYY年MM月DD日') }}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="feedB" v-if="!yydList.length">
			<el-empty description="暂无记录"></el-empty>
		</div>
	</div>
</template>

<script>
export default {
	name: 'feedB',
	data() {
		return {
			flag: false,
			flags: false,
			yydList: [],
			dialogVisible: false,
			lookImg: ''
		};
	},
	methods: {
		lookImgFn(val) {
			this.lookImg = val;
			this.dialogVisible = true;
		},
		init() {
			this.$http.get('api/app/yydFeedback/list').then((res) => {
				console.log(res);
				if (res.code == 200) {
					this.yydList = res.rows.map((item) => {
						return {
							...item,
							isOpen: false
						};
					});
				}
			});
		}
	},
	mounted() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.feedB {
	padding: 22px 21px;
	.feedItem {
		padding: 19px 26px 19px 10px;
		position: relative;
		box-sizing: border-box;
		background: #f9f9f9;
		cursor: pointer;
		border-radius: 10px;
		transition: 1s;
		margin-bottom: 10px;
		.feedH {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}
		.feedTit {
			display: flex;
			align-items: center;
			.feedStatus {
				width: 50px;
				height: 24px;
				line-height: 24px;
				text-align: center;
				color: #fff;
				background: #ff9d32;
				margin-right: 11px;
				border-radius: 6px;
				font-size: 12px;
			}
			.feedStatus1 {
				background: #17b939;
			}
			h2 {
				color: #000000;
				font-size: 16px;
				font-weight: bold;
			}
		}
		.feedIcon {
			display: flex;
			align-items: center;
			color: #ababab;
			font-size: 14px;
			img {
				margin-left: 6px;
				width: 12px;
				height: 6px;
			}
		}
		.feedCont {
			background: #fff;
			margin-top: 17px;
			border-radius: 10px;
			padding: 0 9px;
			display: none;
			.feedContTop {
				padding: 15px 6px 20px;
				box-sizing: border-box;
				border-bottom: 1px dashed #efecec;
				color: #333333;
				font-size: 14px;
				line-height: 2;
			}
			.feedContImgs {
				display: flex;
				flex-wrap: wrap;
				img {
					width: 100px;
					height: 100px;
					margin: 0 15px 15px 0;
					border-radius: 6px;
				}
			}
			.feedContBot {
				.tit {
					margin: 11px 0 10px;
					color: #333333;
					font-weight: bold;
					padding-left: 9px;
				}
				p {
					color: #333333;
					font-size: 14px;
					line-height: 2;
					padding: 0 15px;
				}
				.times {
					color: #8f9190;
					font-size: 12px;
					padding: 4px 15px 18px;
				}
			}
		}
	}
	.active {
		.feedIcon {
			span {
				color: #1d7b3a;
			}
		}
		.feedCont {
			display: block;
		}
	}
}
</style>
